import { Component, OnInit, HostListener } from '@angular/core';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user.service';
import Notiflix from "notiflix";
import { meetingAction, meetingAction_DueToday, AgendaDetails } from '../models/MOMForm';
import { MasterMOMService } from '../services/master-mom.service';

import { ActivatedRoute, Params } from '@angular/router';
import { AdminService } from '../services/admin.service';
import { pairText } from '../models/users';


@Component({
  selector: 'app-meeting-action-list',
  templateUrl: './meeting-action-list.component.html',
  styleUrls: ['./meeting-action-list.component.css'],
  providers: [ToastrUtilsService]
})
export class MeetingActionListComponent implements OnInit {
  noDataImage: any;
  login_UserID: any;
  meetingActionList: any = [];
  pageType: any;
  disableMore: boolean;
  PostStartIndex: number = 1;
  PostMaxCount: number = 10;
  ifcountgreaterthanzero: boolean;
    type: string;
  isLoader: boolean = false;
    strK1: string;
    strI1: string;
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    private userService: UserService,
    public momMasterservice: MasterMOMService,
    private _activatedRoute: ActivatedRoute,
    public restApi: AdminService) { }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.disableMore) {
        this.disableMore = true;

        this.getMoreMeetingAction();
      }

    }
  }
  ngOnInit(): void {
    this.loadpairText();
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.login_UserID = user.id;
    } 
    let that = this;
    setTimeout(function () {
    
      that._activatedRoute.queryParams.subscribe((params: Params) => {
        let QType = params['QType'];
        that.pageType = (QType != null && QType != '') ? atob(QType) : '';
      //that.pageType = 'week'
      if (that.pageType != '') {
        if (that.pageType == 'today') {
          that.type = "Due Today";
        }
        else if (that.pageType == 'tomorrow') {
          that.type = "Due Tomorrow";
        }
        else if (that.pageType == 'week') {
          that.type = "Later that Week";
        }
        that.loadMeetingAction(true);
        that.ifcountgreaterthanzero = false;
        that.PostMaxCount = 10;

      }

    });
    }, 100);
  }

  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getMoreMeetingAction() {
    this.loadMeetingAction(false);
  }
  loadMeetingAction(isStart: boolean) {
    //Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader = true;
    let inpValue = new meetingAction_DueToday();
    inpValue.userUno = this.login_UserID;
    inpValue.pageType = this.pageType;
    this.PostStartIndex = (this.PostStartIndex == undefined || this.PostStartIndex < 1 || isStart) ? 1 : this.PostStartIndex;
    inpValue.startIndex = this.PostStartIndex;
    inpValue.maxCount = this.PostMaxCount;
    this.momMasterservice.getMeetingActionType(inpValue)
      .subscribe(data => {
        ;
        this.isLoader = false;
        if (data != null && data != undefined) {
          if (this.PostStartIndex == 1) {
            this.meetingActionList = [];
          }
          let dataList: any = [];
          dataList = data;
          for (var i = 0; i < dataList.length; i++) {
            let inputData = new meetingAction_DueToday();
            inputData.subjectAtd = data[i].subjectAtd;
            inputData.note = data[i].note;
            inputData.dueDate = data[i].dueDate;
            inputData.userName = data[i].userName;
            inputData.location = data[i].location;
            inputData.progress = data[i].progress;
            this.meetingActionList.push(inputData);
          }
          this.disableMore = (dataList.length >= 10) ? false : true;
          if (dataList.length > 0) {
            this.ifcountgreaterthanzero = true;
            this.PostStartIndex = this.PostStartIndex + 1;
          }
        }
        else {
          this.meetingActionList = [];
        }
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
       
      },
        (error) => {
          //Notiflix.Block.Remove('.pageloadcontainer', 800);
          this.isLoader = false;
        }
    ).add(() => {
     // Notiflix.Block.Remove('.pageloadcontainer', 800);
      this.isLoader = false;
      });
  }


  ResolveConfirm(data: any, progress: number) {
    ;
    let temp = this;
    Notiflix.Confirm.Show('Confirm', 'Are you sure you want to resolve this action?', 'Yes', 'No', function () {

      temp.isLoader = true;
      temp.ResolveTask(data, progress);

    }, function () { // No button callback
      return false;
    });

  }
  ResolveTask(data1: any, progress: number) {

    let obj = new AgendaDetails();
    obj.agendaUno = data1.agendaUno;
    obj.userID = this.login_UserID;
    obj.progress = progress;
    this.momMasterservice.resolveTask(obj)
      .subscribe((data: any) => {
        if (data == 'success') {
          this.loadMeetingAction(true);
          this.toastr.SuccessCustomMessage();

          this.isLoader = false;
        }

        else {
          this.toastr.ErrorMessage();
          this.isLoader = false;
        }
        // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();

          this.isLoader = false;

          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
}
